import apiBootstrap from 'apiBootstrap';

/**
 * Makes sure the real init functions gets called.
 *
 * There are three cases
 * 1. A developer want to have full controll when the help app is shown, they would them self
 *    call init() with the necessary parameters.
 * 2. A developer wants the help app to load automatically as soon as possible, instead of
 *    calling init() they would specify configuration on window.gladlyConfig
 * 3. The customer is using our old loader that does not create our API object that init() can
 *    be called on. Configuration is read from window.gladlyConfig
 */
let config = Object.assign({ autoShowWidget: true }, window.gladlyConfig);
if (window.__onHelpAppHostReady__) {
  window.__onHelpAppHostReady__(apiBootstrap);
  // If configuration is specified in window.gladlyConfig auto start chat
  if (window.gladlyConfig) {
    apiBootstrap.init(config).catch(err => {
      console.error('error:', err.message); // eslint-disable-line no-console
    });
  }
} else {
  // Script loader wasn't found, old loader is used
  apiBootstrap.init(config).catch(err => {
    console.error('error:', err.message); // eslint-disable-line no-console
  });
}
